angular.module('unergie.main')
.controller('statsCtrl', ($timeout, $rootScope, $scope, $state, AlertManager, DataAccess, StatsGraphService, ErrorCatcher, $sce, BoFeaturesService) => {
    $scope.metabaseDashboardUrl = $sce.trustAsResourceUrl(BoFeaturesService.get('metabaseDashboardUrl'))
})
